import { Column } from '@access-erp/common';
import { useMemo } from 'react';

import { getHeaderColumns } from '../columns/headerColumns';
import { useGetredirectLink } from '@/components/common/EnquiriesScreen/utils/useGetRedirectLink';
import { browserHistory } from '@/routing/browserHistory';
import { getParameterizedLink } from '@/utils/getLinkWithSubscriptionId.utils';
import { goToRouteBySearch } from '@/components/common/EnquiriesScreen/utils/goToRouteBySearch';

export interface UseTransactionTableColumnsReturn {
  headerColumns: Column<any>[];
  goToBillingCyclesBySearch: (searchText?: string) => void;
}

export const useColumns = (): UseTransactionTableColumnsReturn => {
  const getRedirectLink = useGetredirectLink();

  const getContractLink = (contractId: string, searchString?: string) => {
    let link = getRedirectLink(window.location.pathname, contractId, searchString);
    return getParameterizedLink(link);
  };

  const goToContract = (contractLink: string) => {
    browserHistory.push(getParameterizedLink(contractLink));
  };

  const goToBillingCyclesBySearch = (searchText?: string) => {
    goToRouteBySearch(searchText);
  };

  return useMemo(() => {
    const headerColumns = getHeaderColumns({ getContractLink, goToContract });
    return {
      headerColumns,
      goToBillingCyclesBySearch,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
